export default __webpack_public_path__ + "static/media/2288.9eb521b4.png";